const downloadBase = 'https://mc-printer-cdn.neyber.tech/app/'

// 打印端下载地址固定不带版本号，发布新版本时只需替换 CDN 上的文件
export const printerDownloads = {
  arm64: `${downloadBase}mc-printer-macos-arm64.dmg`,
  intel: `${downloadBase}mc-printer-macos-intel.dmg`,
  windows: `${downloadBase}mc-printer-windows.exe`
}

export async function getMacArchitecture() {
  const uaData = navigator.userAgentData
  if (!uaData || typeof uaData.getHighEntropyValues !== 'function') {
    return null
  }

  let timer
  try {
    // Some browsers omit or restrict architecture. Keep manual downloads available.
    const result = await Promise.race([
      uaData.getHighEntropyValues(['architecture']),
      new Promise((resolve) => {
        timer = setTimeout(() => resolve({}), 1500)
      })
    ])
    if (result.architecture === 'arm') return 'arm64'
    if (result.architecture === 'x86') return 'intel'
  } catch (error) {
    // Never infer Intel from the Mac user agent: Apple Silicon also reports Intel.
  } finally {
    clearTimeout(timer)
  }
  return null
}
